module.exports = __webpack_public_path__ + "img/debit_card_elements_icon.9b6a7fb5.svg";